// extracted by mini-css-extract-plugin
module.exports = {"circle":"CarouselIndex_circle__1vWGZ","arrowLeft":"CarouselIndex_arrowLeft__17qas","arrowRight":"CarouselIndex_arrowRight__2z7ot"};